enum AdminMessagePriority {
    "High",
    "Medium",
    "Low",
    "Update",
}

export default AdminMessagePriority;